// Menyatukan kontrol kuantitas dan tombol Add to Cart jadi satu baris yang bergerak bersama; lihat docs/README.md §7.
(function () {
  const enableButtonSticky = document.querySelector('.enable_button_sticky');
  const enableQuantitySticky = document.querySelector('.enable_quantity_sticky');
  const stickyCustom = document.querySelector('.sticky_custom');

  if (!enableButtonSticky || !stickyCustom) {
    return;
  }

  // quantity_selector dan buy_buttons block terpisah di theme editor, jadi CSS saja tidak bisa menyatukannya.
  if (enableQuantitySticky && !enableButtonSticky.contains(enableQuantitySticky)) {
    enableButtonSticky.insertBefore(enableQuantitySticky, enableButtonSticky.firstChild);
  }

  // Anchor menandai posisi asal, supaya restore ke desktop tepat -- bukan didorong ke akhir parent.
  const anchor = document.createComment('sticky-anchor');
  enableButtonSticky.parentElement.insertBefore(anchor, enableButtonSticky);

  function moveToStickyCustom() {
    if (window.innerWidth <= 750 && !stickyCustom.contains(enableButtonSticky)) {
      stickyCustom.appendChild(enableButtonSticky);
    }
  }

  function moveToOriginalParent() {
    if (window.innerWidth > 750 && stickyCustom.contains(enableButtonSticky)) {
      anchor.parentElement.insertBefore(enableButtonSticky, anchor);
    }
  }

  function syncStickyPosition() {
    if (window.innerWidth <= 750) {
      moveToStickyCustom();
    } else {
      moveToOriginalParent();
    }
  }

  window.addEventListener('resize', syncStickyPosition);
  syncStickyPosition();
})();
